module.exports = __webpack_public_path__ + "static/media/pigg.02afcbdc.svg";